<template>
  <div class="articleView container">
    <div class="ab">
      <div class="view container">
        <article-title @setWord="setWord" :key-word="keyWord"/>
        <div class="indexData container">
          <div v-for="article in dataLst" :key="article.articleId" class="item container">
            <router-link :to="{name: 'articleDetail',params: {articleId:article.articleId}}">
              <div class="itemImg" v-bind:style="{backgroundImage:'url(' + (article.frontImage || 'http://video.naolamp.com/bbs_front/1529041405718.jpg') + ')',
                backgroundRepeat:'no-repeat', backgroundPosition:'center center', backgroundSize: 'cover'}">
              </div>
            </router-link>
            <div class="itemTitle">
              <router-link :to="{name: 'articleDetail',params: {articleId:article.articleId}}">
                <span :class="article.articleWay">{{article.articleWay | articleWayFilter}}</span>
                <span style="display: inline-block" v-if="article.articleWay === 'Y'">&nbsp;|&nbsp;</span>{{article.title | getTitle}}
              </router-link>
            </div>
            <div class="itemAuthor">
              <router-link :to="{name: 'anotherHome',params: {userId:article.userId}}">
                <img :src="article.headImg || defaultHead"/>
                <span>{{article.userName}}</span>
              </router-link>
            </div>
          </div>
        </div>
      </div>
      <div v-show="MoreShow" class="loadMore" @click="getDataLst">加载更多</div>
      <loading text='加载中...' duration='2s' v-show="isLoad"></loading>
    </div>
  </div>
</template>

<script>
import articleTitle from '../common/articleTitle.vue'
import loading from '../common/loading.vue'
export default {
  name: 'userMain',
  data () {
    return {
      keyWord: '',
      MoreShow: false,
      tabSearchH: '',
      searchIcon: require('../../assets/icon/search_icom.png'),
      v1: require('../../assets/icon/V1.png'),
      msg: '个人首页',
      isLoad: true,
      page: 0,
      pageSize: 6,
      totalPages: 10,
      defaultHead: require('../../assets/image/installer.png'),
      dataTitleVal: 'new',
      dataLst: [{
        'summary': '加载中...',
        'createTime': 1528969629000,
        'handCount': 999,
        'replyCount': 999,
        'tab': 'D32,奥迪,',
        'good': 'N',
        'articleId': 5,
        'lastReplyTime': 1528969629000,
        'open': 'Y',
        'title': '常用车灯用语你懂多少',
        'headImg': null,
        'isRelease': 'Y',
        'userId': '402888c563f7211f0163f721b2d10000',
        'visitCount': 999,
        'userName': '用户9569',
        'articleWay': 'Y',
        'frontImage': 'http://video.naolamp.com/bbs_front/1528969629659.png',
        'top': 'N'
      }]
    }
  },
  computed: {
  },
  mounted: function (s) {
    // 取到路由带过来的参数
    let obj = this.$route.params
    let qo = this.$route.query
    // 将数据放在当前组件的数据内
    if (obj.keyWord) {
      this.keyWord = obj.keyWord
    } else if (qo.keyWord) {
      this.keyWord = qo.keyWord
    }
    this.getDataLst()
  },
  methods: {
    'setWord': function (w) {
      this.keyWord = w
      this.dataLst = []
      this.page = 0
      this.getDataLst()
    },
    'getDataLst': function () {
      this.isLoad = true
      let that = this
      that.page = that.page + 1
      that.axios.post('topic/list', {
        page: that.page,
        keyWords: that.keyWord,
        pageSize: that.pageSize
      }, {
        emulateJSON: true// 需要转json
      }).then(function (response) {
        that.isLoad = false
        if (response.data.status === 0) {
          var res = response.data.value
          if (that.page === 1) {
            that.dataLst = res.dataLst
          } else {
            that.dataLst = that.dataLst.concat(res.dataLst)
          }
          if (res.dataLst.length >= that.pageSize) {
            that.MoreShow = true
          } else {
            that.MoreShow = false
          }
        } else {
          that.$store.commit('setToastMsg', response.data.msg)
        }
      }).catch(function (response) {
        that.isLoad = false
        that.$store.commit('setToastMsg', '网络错误')
      })
    }
  },
  filters: {
    articleTabFilter: function (e) {
      if (e === 'DG_AL') {
        return '灯改案例'
      } else {
        return '产品案例'
      }
    },
    getTitle: function (e) {
      if (!this.keyWord) {
        return e
      } else {
        let aData = []
        let aSearch = this.keyWord.split(' ')
        let k = 0
        let regStr = ''
        let data = e
        for (var r = 0, lenR = aSearch.length; r < lenR; r++) {
          regStr += '(' + aSearch[r] + ')([\\s\\S]*)'
        }
        let reg = new RegExp(regStr)
        for (var i = 0, lenI = data.length; i < lenI; i++) {
          let title = data[i].Title
          let regMatch = title.match(reg)
          let searchData = {}
          k = 0
          if (regMatch !== null) {
            var replaceReturn = ''
            for (var j = 1, lenJ = regMatch.length; j < lenJ; j++) {
              if (regMatch[j] === aSearch[k]) {
                replaceReturn += '<span style="color:red;">$' + j + '</span>'
                k++
              } else {
                replaceReturn += '$' + j
              }
            }
            for (let obj in data[i]) {
              if (data[i].hasOwnProperty(obj)) {
                searchData[obj] = data[i][obj]
              }
            }
            searchData.Title = searchData.Title.replace(reg, replaceReturn)
            aData.push(searchData)
          }
        }
        return aData
      }
    }
  },
  components: {
    articleTitle,
    loading
  },
  watch: {
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.articleView {
  padding-top: 52px;
}
.ab {
  width: 100%;
  min-width: 1200px;
  background-color: #F0F0F0;
}
.articleView .view {
  width: 1200px;
  margin: 0 auto;
}
.indexData {
  float: left;
  width: 1200px;
}
.item {
  width: 390px;
  background-color: #FFFFFF;
  margin: 5px;
  border-radius: 5px;
  text-align: left;
  border-bottom: 1px solid #E3E3E3;
  float: left;
}
.item .itemImg {
  border-radius: 5px 5px 0 0;
  width: 390px;
  height: 230px;
  float: left;
}
.itemTitle {
  padding-left: 20px;
  line-height: 50px;
  color: #333333;
  width: 330px;
  font-size: 18px;
  border-bottom: 1px solid #F0F0F0;
  overflow:hidden;
  text-overflow:ellipsis;
  white-space:nowrap;
}
.itemTitle:hover {
  color: #6b6b6b;
}
.itemTitle .Z {
  background-color: #959eca;
  padding: 2px;
  color: white;
  font-size: 15px;
  display: none;
}
.itemTitle .Y {
  /*background-color: #05B570;*/
  padding: 2px;
  color: #05B570;
  font-size: 18px;
}
.itemAuthor {
  padding-left: 20px;
  color: #999;
  font-size: 12px;
}
.itemAuthor img {
  margin: 10px 0;
  float: left;
  border-radius: 50%;
  height: 30px;
}
.itemAuthor span {
  float: left;
  height: 50px;
  line-height: 50px;
  padding: 0 10px;
  color: #000000;
}
.loadMore {
  font-size: 20px;
  line-height: 50px;
  margin: 30px auto;
  margin-bottom: 0;
  width: 280px;
  height: 50px;
  background-color: #05B570;
  color: #FFFFFF;
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/components/article/articleQuery.vue